/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Document_HintInputs */

const cs_templates_ai_document_hint = /** @type {(inputs: Templates_Ai_Document_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrahuje text a navrhne Typst kostru podle struktury dokumentu.`)
};

const en_templates_ai_document_hint = /** @type {(inputs: Templates_Ai_Document_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracts text and drafts a Typst skeleton from the document structure.`)
};

/**
* | output |
* | --- |
* | "Extracts text and drafts a Typst skeleton from the document structure." |
*
* @param {Templates_Ai_Document_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_document_hint = /** @type {((inputs?: Templates_Ai_Document_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Document_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_document_hint(inputs)
	return cs_templates_ai_document_hint(inputs)
});